export default __webpack_public_path__ + "static/media/wgt-logo.b8c4de37.png";